import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import { LocalesResolver } from 'core/resolvers';
import { RedisComponent } from './redis/redis.component';
import { ActivityComponent } from './activity/activity.component';
import { MetricsComponent } from './metrics/metrics.component';

const monitorRoutes: Routes = [
  {
    path: 'monitor',
    title: 'monitor.title',
    resolve: {
      locales: LocalesResolver
    },
    children: [
      {
        path: 'redis',
        title: 'monitor.redis',
        component: RedisComponent,
        canActivate: [ProfileGuard],
        data: { action: 'monitor.redis' }
      },
      {
        path: 'activity',
        title: 'monitor.activity',
        component: ActivityComponent,
        canActivate: [ProfileGuard],
        data: { action: 'monitor.activity' }
      },
      {
        path: 'metrics',
        title: 'monitor.metrics',
        component: MetricsComponent,
        canActivate: [ProfileGuard],
        data: { action: 'monitor.metrics' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(monitorRoutes)],
  exports: [RouterModule]
})
export class MonitorRoutingModule {}
